import request from "@/utils/request";
// 获取配置详情
export function getSysConfigInfo(init = false) {
  return request({
    url: `/mall/index?init=${init}`
  });
}
